"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Settings = /** @class */ (function () {
    function Settings() {
    }
    Settings.HOST = 'https://mesomb.hachther.com';
    Settings.ALGORITHM = 'HMAC-SHA1';
    Settings.APIVERSION = 'v1.1';
    Settings.LANGUAGE = 'en';
    Settings.VERSION = '1.1.0';
    return Settings;
}());
exports.default = Settings;
